<div class="asc-btn-option">
  <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
    <ng-container *ngFor="let button of buttonList">
      <button 
      [ngClass]="['flex items-center justify-center', button.className? button.className : '']" 
      nz-button 
      [nzTooltipTitle]="button.text"
      [disabled]="button.disabled" 
      nzTooltipPlacement="bottom"
      (click)="hanlder(button)" 
      nz-tooltip
      [nzType]="button.nzType"
      [nzDanger]="button.nzDanger"
      >
      <i 
        *ngIf="button.icon"
        nz-icon 
        [nzType]="button.icon" 
        [nzTheme]="button.znTheme? button.znTheme : 'outline'"
        >
      </i>
      <i *ngIf="button.iconFontAweSome" [ngClass]="button.iconFontAweSome"></i>
    </button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
    <ng-container *ngFor="let button of buttonList">
      <button [ngClass]="['flex items-center justify-center', button.className? button.className : '']" nz-button (click)="hanlder(button)" [nzType]="button.nzType" [nzDanger]="button.nzDanger">
        {{ button.text }}
      </button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
    <ng-container *ngFor="let button of buttonList">
      <button nz-button [ngClass]="['flex items-center justify-center', button.className? button.className : '']" (click)="hanlder(button)" [nzType]="button.nzType" [nzDanger]="button.nzDanger">
        <i 
        *ngIf="button.icon"
        nz-icon 
        [nzType]="button.icon" 
        [nzTheme]="button.znTheme? button.znTheme : 'outline'"
        >
      </i>
      <i *ngIf="button.iconFontAweSome" [ngClass]="button.iconFontAweSome"></i>
        {{ button.text }}
      </button>
    </ng-container>
  </ng-container>
</div>
